var readMoreContainerClass = "read-more-container";
var readMoreLinkClass = "read-more-link";
var readMoreStr = "..Daha fazla";
var readLessStr = "Daha az";
var originalPClass = "more-text";
var trimmedPClass = "less-text";
var wordLimit = 32;

var documentWidth = document.body.clientWidth;
if (documentWidth <= 768 && documentWidth > 740) {
  wordLimit = 22;
} else if (documentWidth < 740) {
  wordLimit = 18;
}



function makeThemMoreReadable(selectorStr) {
  var pList = document.querySelectorAll(selectorStr);

  for(var i = 0; i < pList.length; i++) {
    var originalP = document.createElement("p");
    originalP.innerText = pList[i].innerText;

    //first create the container
    var readMoreContainer = document.createElement("div");
    readMoreContainer.classList.add(readMoreContainerClass);


    //change the original p's class
    originalP.classList.add(originalPClass);


    //duplicate original p
    var trimmedP = document.createElement("p");

    //trim text and add class
    trimmedP.innerText = originalP.innerText.split(" ").splice(0, wordLimit).join(" ");
    trimmedP.classList.add(trimmedPClass);

    //set initial visibilities
    originalP.style.display = "none";
    trimmedP.style.display = "inline";

    //create read more trigger
    var readMoreLink = document.createElement("p");
    readMoreLink.innerText = readMoreStr;
    readMoreLink.classList.add(readMoreLinkClass);
    readMoreLink.style.display = "inline";
    readMoreLink.dataset.toggle = "less";

    //attach listener

    readMoreLink.addEventListener("click", function (e) {
      console.log(e.target.dataset);
      var container = e.target.parentElement;
      var originalP = container.getElementsByClassName(originalPClass)[0];
      var trimmedP = container.getElementsByClassName(trimmedPClass)[0];

      //toggled, so it should hide the trimmed
      //and display the original
      if(e.target.dataset.toggle == "more") {
        originalP.style.display = "none";
        trimmedP.style.display = "inline";
        e.target.innerText = readMoreStr;
        e.target.dataset.toggle = "less";
      } else {
        originalP.style.display = "inline";
        trimmedP.style.display = "none";
        e.target.innerText = readLessStr;
        e.target.dataset.toggle = "more";
      }

    });

    //add all of them to the container
    readMoreContainer.appendChild(originalP);
    readMoreContainer.appendChild(trimmedP);
    readMoreContainer.appendChild(readMoreLink);


    //replace p with container
    var parent = pList[i].parentElement;
    parent.removeChild(pList[i]);
    parent.appendChild(readMoreContainer);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  makeThemMoreReadable(".read-more p");
  makeThemMoreReadable("#shopify-section-collection-template .rte");
});
